import { getBaseUrl } from 'utils/api'
import { timezoneDate } from 'utils/helpers'

export const getProposalFileName = (dealName, companyName, createdAt, version) => {
  const dateString = createdAt ? timezoneDate(createdAt, 'h:mmA', ' ') : ''
  return `${dealName} - Proposal for ${companyName} ${dateString} ${version}.pdf`
}

export const getCurrentVersionInfo = (currentVersion, versionList) => {
  return versionList && versionList.find(v => v.version === currentVersion)
}

export const getFileBaseUrl = () => {
  const baseUrl = getBaseUrl('/v1')
  return `${baseUrl}/test/get-s3-object`
}
